import React from 'react';
import { Container } from 'semantic-ui-react';

import HelpContent from '../../help/index.mdx';

const HelpPage = () => {
    return (
        <Container>
            <HelpContent />
        </Container>
    );
};

export default HelpPage;
